import Groowtorial from 'actions/groowtorial';

export default Groowtorial.createReducer();